// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "2fcafdbfd7befc28cb62" + "/js/" + chunkId + ".js";
};